import { useEffect, useState } from 'react';
import api from '../lib/api';
import ExplorerAvatar from '../components/ExplorerAvatar';

const TABS = [
  { key: 'xp', label: 'XP' },
  { key: 'species', label: 'Species' },
  { key: 'score', label: 'Top Score' },
  { key: 'streak', label: 'Streak' },
];

export default function Leaderboard() {
  const [tab, setTab] = useState('xp');
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/leaderboard?sort=${tab}&limit=25`).then(r => setRows(r.data)).catch(() => {}); }, [tab]);

  return (
    <div className="space-y-5" data-testid="leaderboard-root">
      <h2 className="font-serif text-3xl">Leaderboard</h2>
      <div className="flex gap-2 overflow-x-auto -mx-5 px-5">
        {TABS.map(t => (
          <button key={t.key} data-testid={`lb-tab-${t.key}`} onClick={() => setTab(t.key)} className={`px-4 py-2 rounded-full text-xs whitespace-nowrap ${tab === t.key ? 'bg-accent text-black font-medium' : 'bg-card border border-white/5 text-muted-foreground'}`}>{t.label}</button>
        ))}
      </div>
      <div className="rounded-3xl bg-card border border-white/5 overflow-hidden">
        {rows.map((u) => {
          const val = tab === 'xp' ? `${u.xp.toLocaleString()} XP` :
                      tab === 'species' ? `${u.species_count} species` :
                      tab === 'score' ? `${u.top_discovery_score}` :
                      `${u.streak}d`;
          return (
            <div key={u.user_id} className="flex items-center gap-3 p-4 border-b border-white/5 last:border-0" data-testid="lb-row">
              <span className="font-mono text-sm text-muted-foreground w-6">#{u.rank}</span>
              <ExplorerAvatar src={u.picture} name={u.name} founder={!!u.is_founder} size="w-9 h-9" />
              <div className="flex-1 min-w-0">
                <p className="text-sm truncate flex items-center gap-1.5">
                  {u.name}
                  {u.is_founder && (
                    <span data-testid="lb-founder-star" title="Founder"
                          className="text-[10px] leading-none" style={{ color: '#E9C46A' }}>★</span>
                  )}
                </p>
                <p className="text-[10px] text-muted-foreground">Level {u.level}</p>
              </div>
              <span className="font-mono text-xs text-accent whitespace-nowrap">{val}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
